<template>
  <div>
    <v-list three-line v-if="value">
      <v-list-item v-if="alterar" key="novo-endereco">
        <v-list-item-content>
          <v-btn text color="primary" @click="$store.commit('entidade/novoEndereco')">
            <v-icon class="mr-2">mdi-map-marker-plus</v-icon>NOVO ENDEREÇO
          </v-btn>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="value.length === 0">
        <v-list-item-content class="text-center">
          <i>Nenhum endereço disponível</i>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-for="(endereco, i) in value" :key="`endereco-${i}`">
        <v-list-item-content>
          <v-list-item-subtitle>
            {{endereco.nome}}
            <span v-if="endereco.principal">&nbsp;(principal)</span>
            <v-chip
              x-small
              class="ml-2"
              v-for="(tipo, j) in endereco.tipos"
              :key="`endereco-${i}-tipo-${j}`"
            >{{ strTipoEndereco(tipo) }}</v-chip>
          </v-list-item-subtitle>
          <v-list-item-title>
            <span v-html="strEndereco(endereco)" />
            <v-tooltip bottom v-if="endereco.descricao && endereco.descricao !== ''">
              <template v-slot:activator="{on}">
                <v-icon v-on="on" color="info" class="ml-1">mdi-information-outline</v-icon>
              </template>
              <span>{{endereco.descricao}}</span>
            </v-tooltip>
            <icone-item-entidade :item="endereco" class="ml-1" />
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action v-if="alterar && podeEditar(endereco)">
          <v-speed-dial direction="left" v-if="!endereco.novo && !endereco.remover">
            <template v-slot:activator>
              <v-btn depressed icon fab small>
                <v-icon class="mdi mdi-dots-vertical" />
              </v-btn>
            </template>
            <v-btn icon @click="$store.commit('entidade/editarEndereco', endereco)">
              <v-icon>mdi-pencil-outline</v-icon>
            </v-btn>
            <v-btn
              icon
              color="error"
              @click="$set(endereco, 'remover', true)"
              title="Marcar endereco para remoção"
            >
              <v-icon>mdi-delete-outline</v-icon>
            </v-btn>
          </v-speed-dial>
          <v-btn
            v-if="endereco.remover"
            icon
            @click="endereco.remover = false"
            title="Recuperar endereco"
          >
            <v-icon>mdi-undo</v-icon>
          </v-btn>
          <v-btn
            v-if="endereco.novo"
            icon
            color="error"
            @click="removerNovo(endereco)"
            title="Cancelar novo endereco"
          >
            <v-icon>mdi-cancel</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <form-endereco-dialog v-if="alterar" @change="changeEndereco($event)" />
  </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
import FormEnderecoDialog from "./FormEnderecoDialog";
import IconeItemEntidade from "./IconeItemEntidade";
export default {
  components: { FormEnderecoDialog, IconeItemEntidade },
  props: {
    alterar: Boolean,
    value: Array
  },
  computed: mapState({
    perms: state => state.usuarios.usuarioAtivo.permissoes
  }),
  methods: {
    removerNovo(endereco) {
      const enderecos = _.clone(this.value);
      const idx = enderecos.indexOf(endereco);
      if (idx > -1) {
        enderecos.splice(idx, 1);
      }
      this.$emit("input", enderecos);
    },
    changeEndereco(endereco) {
      let enderecos = _.clone(this.value);
      if (endereco.novo) {
        enderecos.push(endereco);
      } else {
        enderecos = enderecos.map(e => (e.id === endereco.id ? endereco : e));
      }

      if (endereco.principal) {
        enderecos = enderecos.map(e => {
          if (e == endereco) {
            return e;
          }
          e.principal = false;
          return e;
        });
      }

      this.$emit("input", enderecos);
    },
    strEndereco(endereco) {
      let str = endereco.endereco;
      str += endereco.numero !== "" ? `, ${endereco.numero}` : "";
      str += ` ${endereco.complemento} &mdash; ${endereco.bairro}`;
      str += `<br>CEP: ${endereco.cep.substr(0, 5)}-${endereco.cep.substr(
        -3
      )} &mdash; ${endereco.cidade.nome}, ${endereco.cidade.estado.sigla}`;
      return str;
    },
    strTipoEndereco(tipo) {
      return this.$store.getters["entidade/strTipoEndereco"](tipo);
    },
    podeEditar(endereco) {
      if (endereco.tipos.includes("receita")) {
        return this.perms.includes("cliente.editar_dados_receita");
      }
      return true;
    }
  }
};
</script>
